'use strict'

const SEQ_INDEX = 2
const WRITE_INDEX = 4
const READ_INDEX = 8

module.exports = {
  WRITE_INDEX,
  READ_INDEX,
  SEQ_INDEX
}
